<a (click)="redirect()" [class]="linkClass ? linkClass : ''"
   [rel]="target === '_blank' ? 'noopener' : (rel ? rel : '')" [target]="target"
   class="ext-link">
  <ng-content select="[body]"></ng-content>
</a>
